// JOBE-0106: DocumentsTab — full-grid <EntityBrowser> instance
// namespaced "documents" with default `type=document` chip.

import React, { useMemo } from 'react';
import { EntityBrowser } from '../../entitybrowser/EntityBrowser.jsx';
import { FRIENDLY_TOKENS } from '../../library/chipVocabulary.js';

export function DocumentsTab({ projectURN, roster }) {
  const defaultChips = useMemo(() => ([{
    kind: 'predicate',
    friendlyToken: 'type',
    wirePredicate: FRIENDLY_TOKENS.type?.wirePredicate || 'type',
    values: ['document'],
  }]), []);
  return (
    <div className="project-tab project-tab-documents" data-testid="project-tab-documents">
      <EntityBrowser
        anchor={{ inProject: projectURN }}
        urlStateNamespace="documents"
        roster={roster}
        defaultChips={defaultChips}
      />
    </div>
  );
}
